
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import { getBranchOrderList, getBranchOrderProgressList, getBranchOrderDetail, exportBranchOrdersData } from '../../api/branch';
import { exportBranchOrder } from '@/api/order';
import commonProgress from '@/components/CommonProgress/index.vue';
import DialogOrderDetail from '@/components/OrderDetail/index.vue';
import DialogBranch from './components/BranchDialog.vue';
import DialogSelectedBranchServicer from './components/BranchServicer.vue';
import DialogImgLarge from '@/components/ImgLarge/index.vue';

@Component({
  name: 'BranchOrderCustomer',
  components: {
    DialogOrderDetail,
    commonProgress,
    DialogBranch,
    DialogImgLarge,
    DialogSelectedBranchServicer
  }
})
export default class extends Vue {
  private formSearch:any = {
    addtimeRange: [],
    orderstate: '',
    ordernumber: '',
    branch: '',
    servicer: {}
  }
  private pickerOptions:any = {
    shortcuts: [{
      text: '今天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); //
        const end = new Date(today); 
        const start = new Date(today); 
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '昨天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近7天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick(picker: any) {
     const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  }
  private orderStatusOptions = [
    { value: '2', label: '进行中' },
    { value: '3', label: '待验收' },
    { value: '5', label: '已完成' }
  ];

  private listQuery = {
    page: 1,
    size: 10,
    total: 0
  };

  created() {
    this.formSearch.addtimeRange[0] = this.modifyDateFormat(new Date().getFullYear() - 1, new Date().getMonth(), new Date().getDate());
    this.formSearch.addtimeRange[1] = new Date().getTime();
    this.getOrderList();
  }

  modifyDateFormat(y: any, m: any, d: any) {
    return new Date(y, m, d, 0, 0, 0).getTime();
  }

  exportHandle(r: any) {
    // 工作单导出
    const url = r.order.order_elec.save_path as string;
    const filename = url.split('/').slice(-1)[0];
    try {
      if ('download' in document.createElement('a')) {
        // 非IE下载
        let elink = document.createElement('a');
        elink.download = filename;
        elink.style.display = 'none';
        elink.href = url;
        elink.target = '_blank';
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      } else {
        // IE10+下载
        // navigator.msSaveBlob(blob, fileName);
      }
      this.$message.success('下载文件成功');
    } catch (err) {
      let msg = '';
    }
  }

  getManyDays() {
    let yyyy = 365;
    let y = new Date().getFullYear();
    let flag = y % 400 === 0 || (y % 4 === 0 && y % 100 !== 0);
    if (flag) {
      yyyy = 366;
    }
    return yyyy;
  }

  handleSearch() {
    this.listQuery.page = 1;
    if (this.formSearch.addtimeRange[1] - this.formSearch.addtimeRange[0] > 1000 * 60 * 60 * 24 * this.getManyDays() + 1000 * 60 * 60 * 24) {
      this.$notify.error({
        title: '错误',
        message: '报修日期最大查询跨度为1年',
        offset: window.innerHeight * 0.4,
        customClass: 'notification-center',
        type: 'warning'
      });
      return false;
    }
    this.getOrderList();
  }

  handleClearSearch() {
    this.formSearch.addtimeRange[0] = this.modifyDateFormat(new Date().getFullYear() - 1, new Date().getMonth(), new Date().getDate());
    this.formSearch.addtimeRange[1] = new Date().getTime();
    this.formSearch.branch = '';
    this.formSearch.ordernumber = '';
    this.formSearch.servicer = {};
    this.formSearch.orderstate = '';
    this.listQuery.page = 1;
    this.$route.query.order_num = '';

    this.getOrderList();
  }

  handleCurrentChange(val: number) {
    this.listQuery.page = val;
    this.getOrderList();
  }

  handleSizeChange(val: number) {
    this.listQuery.size = val;
    this.listQuery.page = 1;
    this.getOrderList();
  }

  private dialogSelectBranchServicerVisible = false
  private handleSelectBranchServicer(row: any) {
    this.dialogSelectBranchServicerVisible = false;
    this.formSearch.servicer = row;
  }
  private closeSelectBranchServicer(value: boolean) {
    this.dialogSelectBranchServicerVisible = value;
  }

  private dialogOrderDetailVisible = false
  private detail = {
    order: {
      reminder: {}
    },
    order_service: { transfer_out_from: {} },
    order_quote: {}
  }
  private isOrderProgress = false;
  private orderProgressData = {};

  detailHandle(row: any, index: 2) {
    this.dialogOrderDetailVisible = true;
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      branch_company_id: row.order.customer_company_id,
      order_id: row.order.id
    };
    getBranchOrderDetail(params).then(res => {
      const data = res.data;
      if (data !== null) {
        this.detail = res.data;
      }
    }).catch(err => {
      let msg = err.msg;
    });

    const pparams = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      branch_company_id: row.order.customer_company_id,
      order_id: row.order.id
    };
    getBranchOrderProgressList(pparams).then(res => {
      const data = res.data;
      if (data !== null) {
        this.orderProgressData = data;
      } else {
        this.orderProgressData = {};
      }
    }).catch(err => {
      this.orderProgressData = {};
      this.showErrorMsg(err.msg);
    });

    if (index === 2) {
      this.isOrderProgress = true;
    } else {
      this.isOrderProgress = false;
    }
  }
  closeDetailHandle(value: boolean) {
    this.dialogOrderDetailVisible = value;
  }

  private selectedServicerHandle() {
    this.dialogSelectBranchServicerVisible = true;
  }

  private listLoading = false;
  private orderList = []

  private getOrderList() {
    this.listLoading = true;
    if (this.$route.query.order_num) {
      this.formSearch.ordernumber = this.$route.query.order_num;
    }

    const params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      branch_company_name: this.formSearch.branch.name,
      servicer_company_name: this.formSearch.servicer.name,
      order_num: this.formSearch.ordernumber,
      stage: this.formSearch.orderstate,
      start_time: this.formSearch.addtimeRange[0].toString().substring(0, 10),
      end_time: this.formSearch.addtimeRange[1].toString().substring(0, 10),
      page: this.listQuery.page,
      size: this.listQuery.size
    };
    // 统计报表跳转
    if (this.$route.query.branch_company_id && this.$route.query.branch_company_id !== UserModule.getCompanyId) {
      params.branch_company_id = this.$route.query.branch_company_id;
    }
    getBranchOrderList(params).then(res => {
      this.listLoading = false;
      if (res && res.data) {
        this.orderList = res.data.list;
        this.listQuery.total = res.data.count;
      } else {
        if (this.listQuery.page === 1) {
          this.listQuery.total = 0;
        }
        this.orderList = [];
      }
    }).catch(err => {
      if (this.listQuery.page === 1) {
        this.listQuery.total = 0;
      }
      this.listLoading = false;
      let msg = err.msg;
    });
  }

  private arraySpanMethod(IOrderColspan:any) {
    if (IOrderColspan.columnIndex === 0) {
      return [1, 7];
    } else if (IOrderColspan.columnIndex === 1 || IOrderColspan.columnIndex === 2 || IOrderColspan.columnIndex === 3 || IOrderColspan.columnIndex === 4 || IOrderColspan.columnIndex === 5 || IOrderColspan.columnIndex === 6) {
      return [0, 0];
    }
  }

  getTagsHtml(r:any) {
    let kind = ''; let kindType = ''; let plain = 'plain';
    if (parseInt(r.order.order_type) === 1) {
      kind = '其他';
      kindType = 'warning';
    } else if (parseInt(r.order.order_type) === 2) {
      kind = '维保';
      kindType = 'success';
    } else if (parseInt(r.order.order_type) === 3) {
      kind = '安装';
      kindType = 'danger';
    } else if (parseInt(r.order.order_type) === 4) {
      kind = '巡检';
      kindType = '';
    } else {
      kind = '维保';
      kindType = 'success';
    }

    let charge = ''; let darkplain = 'dark';
    if (parseInt(r.order_service.charge) === 1) {
      charge = '收费';
    }

    let expedited = '';
    if (parseInt(r.order_service.expedited) === 1) {
      expedited = '加急';
    }

    // 2019-05-23 迭代 订单排位
    var ranking = '';
    if (parseInt(r.order_service.is_ranking) === 1) {
      var rankingNum = parseInt(r.order_service.ranking);
      if (rankingNum) {
        ranking = rankingNum + '号';
      }
    }

    // 审核标识
    let check = '';
    if (parseInt(r.order.check_state) === 11 || parseInt(r.order.check_state) === 51) {
      check = '审核';
    }

    return [{
      type: kindType, label: kind, plain: plain
    }, {
      type: 'danger', label: charge, plain: darkplain
    }, {
      type: 'danger', label: expedited, plain: darkplain
    }, {
      type: 'danger', label: ranking, plain: darkplain
    }, {
      type: 'warning', label: check, plain: darkplain
    }];
  }

  private branchVisible = false
  private selectBranchHandle() {
    this.branchVisible = true;
  }
  closeBranchHandle(value: boolean) {
    this.branchVisible = value;
  }
  handleSelectedBanch(row: any) {
    this.branchVisible = false;
    this.formSearch.branch = row;
  }

  // 导出Excel
  private exportVisible = false;
  private exportCount = 0;
  private exportCurrentCount = 0;
  private exportTime = '';
  private downloadUrl = '';
  handleExport() {
    if (this.formSearch.addtimeRange[1] - this.formSearch.addtimeRange[0] > 1000 * 60 * 60 * (24 * 31 + 24)) {
      this.$notify.error({
        title: '错误',
        message: '导出订单仅支持报修日期，并且范围须为一个月内',
        offset: window.innerHeight * 0.4,
        customClass: 'notification-center',
        type: 'warning'
      });
      return false;
    }

    let params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      branch_company_name: this.formSearch.branch.name,
      servicer_company_name: this.formSearch.servicer.name,
      order_num: this.formSearch.ordernumber,
      start_time: this.formSearch.addtimeRange[0].toString().substring(0, 10),
      end_time: this.formSearch.addtimeRange[1].toString().substring(0, 10),
      stage: this.formSearch.orderstate,
      page: 1,
      size: 10
    };
    exportBranchOrder(params).then((res:any) => {
      this.showSecussMsg(res.msg);
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  private imgLargeHandle(val: [], index: number) {
    let enlargedData = {
      isShow: true,
      imgList: val,
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
